/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) 2021 Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { components } from '@glowingblue-orell-thalia-common';
import type HomeActivityLeaderboardState from '@glowingblue-orell-thalia-common/states/HomeActivityLeaderboardState';
import type Mithril from 'mithril';
import type Model from 'flarum/common/Model';
import ActiveBookshelfItem from './ActiveBookshelfItem';
import HomeBookshelvesLeaderboardState from '../states/HomeBookshelvesLeaderboardState';
import type Bookshelf from '../../common/models/Bookshelf';

export default class HomeBookshelvesLeaderboard extends components.HomeActivityLeaderboard {
	// `HomeActivityLeaderboard` is not generic — it hard-codes `User` — hence the widening here and
	// the cast in `stateManager`.
	listItem(item: Model, position: number): JSX.Element {
		return <ActiveBookshelfItem bookshelf={item as Bookshelf} position={position} />;
	}

	get titleText(): Mithril.Children {
		return app.translator.trans('glowingblue-orell-bookshelf.forum.home.active_bookshelves.title');
	}

	get subTitleText(): Mithril.Children {
		return app.translator.trans('glowingblue-orell-bookshelf.forum.home.active_bookshelves.sub_title', { days: this.nDays });
	}

	get emptyText(): Mithril.Children {
		return app.translator.trans('glowingblue-orell-bookshelf.forum.home.active_bookshelves.empty_text', { days: this.nDays });
	}

	get stateManager(): new () => HomeActivityLeaderboardState {
		return HomeBookshelvesLeaderboardState as unknown as new () => HomeActivityLeaderboardState;
	}
}
